import { render } from "./index.vue?vue&type=template&id=5e8d79ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5e8d79ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e8d79ba"

export default script